import { createGlobalStyle } from 'styled-components'
import sanitize from 'sanitize.css'
import reactToastify from 'react-toastify/dist/ReactToastify.css'
import reactDatesStyles from 'react-dates/lib/css/_datepicker.css'

export default createGlobalStyle`
  ${sanitize}
  ${reactToastify}

  * {
    box-sizing: border-box;
    outline: none;
    margin: 0;
    padding: 0;
  }

  html, body,
  #root {
    height: 100vh;
    min-height: 100vh;
    max-height: 100vh;
  }

  /**
  * Typography
  */
  @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:400,700,800&display=swap');

  body, button {
    font-family: ${props => props.theme.fonts.body};
    font-size: ${props => props.theme.fontSizes.body};
    color: ${props => props.theme.colors.text};
  }

  a {
    color: ${props => props.theme.colors.text};
    text-decoration: underline;

    :hover {
      text-decoration: none;
    }
  }

  ${reactDatesStyles}
`
